import React from "react";
import { Box, IconButton, MenuItem, Select, Typography } from "@mui/material";
import {
  ChevronLeft,
  ChevronRight,
  FirstPage,
  LastPage,
} from "@mui/icons-material";

const CustomPagination = ({
  rowsPerPage,
  rowCount,
  onChangePage,
  onChangeRowsPerPage,
  currentPage,
  paginationRowsPerPageOptions = [10, 20, 50],
}) => {
  const totalPages = Math.ceil(rowCount / rowsPerPage);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage >= totalPages;

  const handleFirstPageClick = () => {
    if (!isFirstPage) {
      onChangePage(1);
    }
  };

  const handlePreviousPageClick = () => {
    if (!isFirstPage) {
      onChangePage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    if (!isLastPage) {
      onChangePage(currentPage + 1);
    }
  };

  const handleLastPageClick = () => {
    if (!isLastPage) {
      onChangePage(totalPages);
    }
  };

  const handleRowsPerPageChange = (event) => {
    onChangeRowsPerPage(Number(event.target.value));
  };

  const startRow = rowCount === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1;
  const endRow = Math.min(currentPage * rowsPerPage, rowCount);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "16px",
        gap: 2,
        borderTop: "1px solid rgba(224, 224, 224, 1)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
          Rows per page:
        </Typography>
        <Select
          value={rowsPerPage}
          onChange={handleRowsPerPageChange}
          size="small"
          sx={{ minWidth: 70 }}
        >
          {paginationRowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Typography variant="body2" sx={{ whiteSpace: "nowrap" }}>
        {startRow}-{endRow} of {rowCount}
      </Typography>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        {!isFirstPage && (
          <>
            <IconButton
              onClick={handleFirstPageClick}
              disabled={isFirstPage}
              size="small"
              aria-label="first page"
            >
              <FirstPage />
            </IconButton>
            <IconButton
              onClick={handlePreviousPageClick}
              disabled={isFirstPage}
              size="small"
              aria-label="previous page"
            >
              <ChevronLeft />
            </IconButton>
          </>
        )}

        {!isLastPage && (
          <>
            <IconButton
              onClick={handleNextPageClick}
              disabled={isLastPage}
              size="small"
              aria-label="next page"
            >
              <ChevronRight />
            </IconButton>
            <IconButton
              onClick={handleLastPageClick}
              disabled={isLastPage}
              size="small"
              aria-label="last page"
            >
              <LastPage />
            </IconButton>
          </>
        )}
      </Box>
    </Box>
  );
};

export default CustomPagination;
